<template>
  <div id="locker-view-container">
    <ProjectNavbar
      v-if="dealerMode"
      :hideEditButton="true"
      @openShareProjectModal="toggleShareProjectModal"
    />

    <transition name="fade">
      <ShareProjectModal
        v-if="showShareProjectModal"
        :isModalOpen="showShareProjectModal"
        @close="toggleShareProjectModal"
    /></transition>

    <DealerHeader @openDealerLoginModal="openDealerLoginModal" />
    <GameplanLocker
      :dealerMode="!!dealerMode"
      :projectStatus="projectStatus"
      :projectRoute="projectRoute"
      @requestQuoteSucceded="handleQuoteSuccess"
      @requestOmgStoresSuccess="updateProjectStatus(PROJECT_STATUS.OMG_STATUS)"
      @addRoster="goToRosterPage"
      @goToSizesPage="goToSizesSelectionPage"
      @editProduct="goToActiveProductPage"
      :showPrices="showProjectPrices"
    />
    <transition name="fade">
      <DealerLoginModal
        v-if="showDealerLoginModal"
        @close="closeDealerLoginModal"
    /></transition>

    <!-- Project overlay for complete/archived/closed projects -->
    <ProjectLockOverlay v-if="projectIsLocked" />
  </div>
</template>

<script>
import DealerHeader from "@/components/Projects/Project/DealerHeader";
import DealerLoginModal from "@/components/Projects/Project/DealerLoginModal";
import ProjectLockOverlay from "@/components/Projects/Project/ProjectLockOverlay";
import ProjectNavbar from "@/components/Projects/Project/ProjectNavbar";
import ShareProjectModal from "@/components/Projects/Project/ShareProjectModal.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import CONSTANTS from "@/constants.js";
export default {
  name: "LockerContainer",

  data() {
    return {
      showDealerLoginModal: false,
      showShareProjectModal: false,
    };
  },

  computed: {
    ...mapState(["lockerModule"]),
    ...mapState("auth", ["dealerMode"]),
    ...mapState("dealer", ["rhino_code", "fsg_code"]),
    ...mapState("project", ["typeOfProject"]),
    ...mapGetters("project", [
      "projectId",
      "projectIsLocked",
      "projectRoute",
      "projectStatus",
      "showProjectPrices",
    ]),
    ...mapGetters("showroom", ["dealerCode"]),

    PROJECT_STATUS() {
      return CONSTANTS.PROJECT_STATUS;
    },
  },

  methods: {
    ...mapActions("project", [
      "createBuilderConfigsForQuoteProducts",
      "goToActiveProductPage",
      "initProject",
      "setActiveProduct",
      "updateProjectStatus",
    ]),

    openDealerLoginModal() {
      this.showDealerLoginModal = true;
    },
    closeDealerLoginModal() {
      this.showDealerLoginModal = false;
    },

    goToRosterPage(product) {
      this.goToPage(product, "roster");
    },

    goToSizesSelectionPage(product) {
      this.goToPage(product, "sizes-selection");
    },

    goToPage(product, route) {
      this.setActiveProduct({
        product: {
          ...product,
          styleName: product.style_name,
          designName: product.design_name,
        },
      });

      //Redirect to the active product page
      const short_id = product.short_id;
      const typeOfProject = this.typeOfProject + "s";
      let url;
      if (typeOfProject === "showrooms") {
        url = `/${typeOfProject}/${this.dealerCode}/${route}?short_id=${short_id}`;
      } else {
        url = `/${typeOfProject}/${this.rhino_code}/${this.projectId}/${route}?short_id=${short_id}`;
      }
      this.$router.push(url);
    },

    async handleQuoteSuccess() {
      await this.updateProjectStatus(this.PROJECT_STATUS.QUOTE_STATUS);
      // await this.createBuilderConfigsForQuoteProducts();
    },

    toggleShareProjectModal() {
      this.showShareProjectModal = !this.showShareProjectModal;
    },
  },

  async mounted() {
    await this.initProject();
  },
  components: {
    DealerHeader,
    DealerLoginModal,
    ProjectLockOverlay,
    ProjectNavbar,
    ShareProjectModal,
  },
};
</script>
<style lang="scss" scoped>
#locker-view-container {
  background-color: $grey-lightest;
  padding: 0;
  margin: auto;
  min-height: 100vh;
  position: relative;
  * {
    color: black;
  }

  ::v-deep {
    .product-product-name,
    .price-number,
    form .form-header h3 {
      font-family: "SlateStd-Bold", arial, sans-serif;

      strong {
        font-family: "SlateStd-Bold", arial, sans-serif;
      }
    }
  }
}

.btn {
  background: #f9f9f9;
  font-size: 1rem;
  font-family: Ubuntu Bold;
  text-transform: uppercase;
  border: 1px solid #707070 !important;
  border-radius: 5px;
  padding: 0.2rem 2rem 0.4rem 2rem;
  margin: auto;
  display: block;
  width: 250px;
  margin-top: 2rem;

  box-shadow: 0 3px 6px -2px #707070;

  color: #252525;
  text-decoration: none;
  text-align: center;

  font-weight: bold;
  text-transform: uppercase;
  transition: box-shadow 0.2s ease;
  transition: background-color 0.15s ease;
  transition: color 0.15s ease;
  transition: transform 0.15s ease;

  &:hover {
    box-shadow: 0 0 8px 1px #00000099;
    background-color: black;
    color: white !important;

    transform: scale(1.05);
  }
}
</style>
